// Mock data for Madhur Lottery (kept as fallback; primary data comes from API)

export const SITE = {
  name: "Madhur Lottery",
  tagline: "Result Today, Chart History & Daily Updates",
  logoText: "Madhur",
  founded: "2012",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Madhur Chart", to: "/madhur-chart" },
  { label: "Starline Chart", to: "/starline-chart" },
  { label: "About", to: "/about" },
];

export const todayLabel = () => {
  const d = new Date();
  return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
};

export const lastUpdated = () => {
  const d = new Date();
  const date = d.toLocaleDateString("en-IN", { day: "2-digit", month: "long", year: "numeric" });
  const time = d.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", hour12: true });
  return `${date} at ${time}`;
};

export const todayISO = () => new Date().toISOString().slice(0, 10);

export const CHART_YEARS = [2026, 2025, 2024, 2023, 2022];

export const FAQS = [
  {
    q: "Madhur Lottery ka result kitne baje aata hai?",
    a: "Madhur Lottery ka result daily fixed schedule par update hota hai. Exact timing dekhne ke liye homepage par live result table track karein.",
  },
  {
    q: "Purana Madhur chart kaise dekhein?",
    a: "Website ke 'Chart Archive' section me jakar aap pichle saalo ke sabhi records aasani se check kar sakte hain.",
  },
  {
    q: "Kya yeh website Madhur result regularly update karti hai?",
    a: "Haan, yeh ek informational website hai jo regularly Madhur Lottery aur Starline ke past aur present results show karti hai.",
  },
  {
    q: "Kya yeh platform betting promote karta hai?",
    a: "Bilkul nahi. Yeh sirf informational purpose ke liye hai. Hum kisi bhi tarah ki gambling promote nahi karte.",
  },
];

export const HIGHLIGHTS = [
  {
    icon: "Activity",
    title: "Live Result Updates",
    desc: "Daily Madhur Lottery results time-by-time as soon as numbers are declared.",
  },
  {
    icon: "BarChart3",
    title: "Complete Chart Archive",
    desc: "Year-wise complete records of Madhur and Starline charts.",
  },
  {
    icon: "Sparkles",
    title: "Starline Records",
    desc: "Starline result archive with date, time and number — clean and searchable.",
  },
  {
    icon: "ShieldCheck",
    title: "Informational Only",
    desc: "Madhur Lottery sirf information ke liye hai, koi betting service nahi.",
  },
];
